module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "asset"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Assets',
      "path": '/asset'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.rows.length === 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("You don't currently have any assets added. Please click one of the Add buttons to get started.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addTractor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Tractor")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addTrailer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Trailer")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.rows.length !== 0),
      expression: "!loading && rows.length !== 0"
    }],
    staticClass: "col-md-12"
  }, [_vm._m(0)])]), _vm._v(" "), (!_vm.loading && _vm.rows.length !== 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addTractor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Tractor")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addTrailer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Trailer")])])]) : _vm._e()])]), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "card-body table-no-bordered dataTable dtr-inline table-full-width"
  }, [_c('div', {
    staticClass: "toolbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables_assets",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Make")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Asset ID")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: " text-right"
  }, [_vm._v("Actions")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-486d2245"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/asset/AssetView.vue
// module id = 704
// module chunks = 0